import hamburgerMenu from './hamburger-menu';
import stickyHeader from './sticky-header';

const documentReady = () => {
	stickyHeader();
	hamburgerMenu();
};

if ( document.readyState !== 'loading' ) {
	documentReady();
} else {
	document.addEventListener( 'DOMContentLoaded', documentReady );
}
